import React from 'react';
import './blog-post.css';
import Googlerecap1 from './pictures/Googlerecap1.jpg';
import Googlerecap2 from './pictures/Googlerecap2.jpg';
import Googlerecap3 from './pictures/Googlerecap3.jpg';
import Googlerecap4 from './pictures/Googlerecap4.jpg';
import Googlerecap5 from './pictures/Googlerecap5.jpg';
import Googlerecap6 from './pictures/Googlerecap6.jpg';
//import reportWebVitals from './reportWebVitals';

const Googlerecap = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Building Your Technical Career with Google Recap</h2>
                    <p class="site-post-meta">October 26th, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    We hosted a Building Your Technical Career with Google event with two women engineers from Google! 
                    WiC members learned a lot about how to build their resumes and technical skills 
                    throughout their 4 years to prepare for internships and full time roles at Google 
                    and received tips and advice from the engineers. Members also had the opportunity to 
                    ask the Google engineers questions about Google and how to build their experience and 
                    technical skills during college! Our speakers enjoyed talking to and answering questions from our attendees! 
                    Thank you so much to everyone who attended - we hope you learned a lot about 
                    building your technical career and opportunities at Google!

                    </p>
                    <img src={Googlerecap1} alt="Introduction of Google guest speakers"/>
                    <img src={Googlerecap2} alt="Introduction of Google guest speakers"/>
                    <img src={Googlerecap3} alt="Presentation about tips and advice to prepare for technical interviews and resume"/>
                    <img src={Googlerecap4} alt="Members asking questions to guest speakers"/>
                    <img src={Googlerecap5} alt="Picture of members attending the event"/>
                    <img src={Googlerecap6} alt="WiC officers and Google guest speakers group photo"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Googlerecap;

